let state = {
    senvenPlayer_status: {
        playing: false, // 播放状态
        cur_src: '', // 目前播放的url
    },
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityPlayer/state.js